module.exports = __webpack_public_path__ + "img/Villa_Borna_35.1a3c6a59.jpg";